import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Home extends Component {
  render() {
    return (
       <div>
        <div className="intro">
        </div>
        <div className="features">
        <div className="container_space" >
          <div className="feature_image kit"/>
            <div className="content_text">
              <div className="content_text_title">Health Sample Kit</div>
              Receive your personalized bio kit over the mail with free shipping and send it to us for comprehensive personalized health analysis to get started and begin benefitting from our hybrid AI and health practitioner expert systems.
            </div>
        </div>
        <div className="container_space" >
          <div className="feature_image watch"/>
          <div className="content_text">
          <div className="content_text_title">Advanced Wearable Applications</div>
          We develop and provide health tracking applications to allow our AI and health experts to help monitor and coach users to improve behaviors that are in-line with reducing health risks, increasing fitness, and achieving personal goals.
          </div>
        </div>
        <div className="container_space" >
          <div className="feature_image desktop"/>
          <div className="content_text">
          <div className="content_text_title">Online Health Portal</div>
          Our web portal serves as an online space for both industry intelligence, as well as a personalized home for customer account and wellness information.  Our customers and partners enjoy access to the best insights from industry and for improving quality of life.
          </div>
        </div>
        <div className="container_space" >
          <div className="feature_image vr_headset"/>
          <div className="content_text">
          <div className="content_text_title">Virtual Reality Environment</div>
          Access your health and wellness environment without leaving home via our VR Wellness Matrix world, where you can review your personal wellbeing as well as connect with health experts and others in your community benefitting from a variety of online features and environments.
          </div>
          </div>

</div>
    <div className="banner product">
    <div className="gradient">
</div>
        </div>
        <div className="banner_callout gray">
          <div className="banner_callout_text">
          At the heart of WMGR is a philosophy of science-based and data-driven intelligence to serve our customers and global health community. 
        </div>
      </div>

        <div className="features">
        <div className="container_space" >
          <div className="feature_image health_monitor"/>
          <div className="content_text">
          <div className="content_text_title">Connected Applications</div>
          We recognize the wellbeing is comprised of a variety of factors and aspects of your life, so we work to bring together the critical dimensions in a user friendly and simplified way to support your best quality of life and longevity.
          </div>
          
        </div>
        <div className="container_space" >
          <div className="feature_image data_application"/>
          <div className="content_text">
          <div className="content_text_title">Data Management</div>
          Our data science practice brings together composite teams of clinical experts, data engineers, and software developers to analyze and develop key insights to improve diagnostics, risk identifications, and recommendation systems, leveraging the entire scope of information we have access to for the benefit of all.
          </div>
          
        </div>
      </div>
        
        <div className="container_space" >
          <div className="">
           </div>
        </div>
        <div className="banner lounge">
  
        </div>
        <div className="container_space" >
          <div className="">
           </div>
        </div>
    </div>
    );
  }
}

export default Home;